<template>
	<div class="page-user-lsit">
		<div class="pg-breadcrumb">
			<div class="breadcrumb-item em">權限管理</div>
			<div class="breadcrumb-item">管理員日誌</div>
		</div>
		
		<div class="card-block">
			<!-- <Form inline class="pg-form-inline">
					 <FormItem>
							 <DatePicker class="no-suffix" type="date" size="small" :clearable="false"
													 placeholder="起始日期" format="yyyy-MM-dd" v-model="form.start_time"></DatePicker>
					 </FormItem>
					 <FormItem>-</FormItem>
					 <FormItem>
							 <DatePicker class="no-suffix" type="date" size="small" :clearable="false"
													 placeholder="結束日期" format="yyyy-MM-dd" v-model="form.end_time"></DatePicker>
					 </FormItem>
			 </Form> -->
			
			<Form inline class="pg-form-inline form-input-wrap">
				<FormItem>
					<label class="input-label">操作員</label>
					<Input size="small" v-model="form.username"/>
				</FormItem>
				<!-- <FormItem>
						<label class="input-label">操作員</label>
						<Input size="small" v-model="form.phone"/>
				</FormItem> -->
				<FormItem>
					<div class="pg-btn-wrap">
						<div class="pg-btn style1" @click="handleSearch">搜索</div>
						<!-- <div class="pg-btn style2">導出excel</div> -->
					</div>
				</FormItem>
			</Form>
		</div>
		
		<div class="card-block pd-bt">
			<Spin fix class="pg-sub-loading" v-if="isSubmiting">
				<Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
				<div class="loading-text">Loading</div>
			</Spin>
			
			<Table size="small"
			       border
			       no-data-text="暫無數據"
			       :columns="table.column"
			       :data="table.data">
			</Table>
			
			<div class="pg-pagger">
				<Row>
					<Col span="12" class="pagger-left">
						<div class="pagger-total">總共{{ totalCount }}條記錄</div>
					</Col>
					<Col span="12" class="pagger-right">
						<!-- v-if="totalCount > curPageSize" -->
						<div>
							<div class="pagger-sizer">
								<span>每頁</span>
								<Select v-model="curPageSize" size="small" placeholder="數量"
								        @on-change="handlePageSizeChange">
									<Option :value="10">10</Option>
									<Option :value="20">20</Option>
									<Option :value="30">30</Option>
									<Option :value="40">40</Option>
									<Option :value="50">50</Option>
									<Option :value="60">60</Option>
									<Option :value="70">70</Option>
									<Option :value="80">80</Option>
									<Option :value="90">90</Option>
									<Option :value="100">100</Option>
								</Select>
							</div>
							
							<div class="pagger-elevator">
								<span>跳轉</span>
								<Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
								       @on-enter="handlePageEnter"/>
							</div>
							
							<Page size="small"
							      :current="pageIndex"
							      :page-size="curPageSize"
							      :total="totalCount"
							      @on-change="handlePageChange">
							</Page>
						</div>
					</Col>
				</Row>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			pageIndex: 1,   //页码
			curPageSize: 10,    //一页数量
			totalCount: 1, //总条数
			pageInput: '',  //输入的页码
			form: {
				username: '',
				user_agent: '',
				description: '',
				start_time: '',
				ip: ''
			},
			
			isSubmiting: false,
			
			table: {
				column: [
					{
						title: '操作者',
						key: 'username',
						align: 'center',
						sortable: true,
						minWidth: 150
					},
					{
						title: '真实姓名',
						key: 'realname',
						align: 'center',
						minWidth: 160
					},
					{
						title: 'IP地址',
						key: 'ip',
						align: 'center',
						sortable: true,
						minWidth: 150
					},
					{
						title: '登入狀態',
						key: 'description',
						align: 'center',
						sortable: true,
						minWidth: 160
					},
					{
						title: '最後登入時間',
						key: 'start_time',
						// slot: 'avatar',
						align: 'center',
						sortable: true,
						minWidth: 160
					},
					// {
					//     title: '操作員ID',
					//     key: 'user_agent',
					//     // slot: 'avatar',
					//     align: 'center',
					//     minWidth: 160
					// }
				],
				data: []
			}
		};
	},
	mounted() {
		this.getList();
	},
	methods: {
		getList() {
			let form = this.form;
			this.isSubmiting = true;
			this.$Rq.requestAuth({
				url: this.$Api.adminLog,
				method: 'get',
				data: {
					offset: (this.pageIndex - 1) * this.curPageSize,
					limit: this.curPageSize,
					admin_name: form.username
				}
			}).then((res) => {
				this.isSubmiting = false;
				if (res.code == 0) {
					let tempArr = [];
					let resData = res.data.data;
					
					for (let i = 0; i < resData.length; i++) {
						tempArr.push({
							// user_id: resData[i].user_id,
							// user_name: resData[i].username,
							// phone: resData[i].phone,
							// avatar: resData[i].avatar,
							// status: resData[i].status,
							// cabinet_name: resData[i].cabinet_name,
							// user_integral: resData[i].user_integral,
							// logDateTime: resData[i].token ? resData[i].token.last_time : ''
							
							user_agent: resData[i].user_agent,
							description: resData[i].description,
							username: resData[i].username,
							start_time: resData[i].start_time,
							ip: resData[i].ip,
							realname: resData[i].realname,
						});
					}
					
					this.totalCount = res.data.count;
					this.table.data = tempArr;
				} else {
					this.showTipInfo(res.msg);
				}
			}).catch((err) => {
				this.isSubmiting = false;
			});
		},
		
		handleSearch() {
			this.pageIndex = 1;
			this.getList();
		},
		
		handleEdit(index) {
			let tableData = this.table.data;
			this.$router.push({path: '/userEdit?id=' + tableData[index].user_id})
		},
		handleIntegral(index) {
			let tableData = this.table.data;
			this.$router.push({path: '/userIntegral?id=' + tableData[index].user_id})
		},
		handleDelete(index, status) {
			this.$Modal.confirm({
				title: '提示',
				content: '確定凍結嗎？',
				cancelText: '取消',
				okText: '確定',
				onOk: () => {
					let tableData = this.table.data;
					this.isSubmiting = true;
					
					this.$Rq.requestAuth({
						url: this.$Api.userDelete + '/' + tableData[index].user_id,
						method: 'post',
						data: {
							status: status, //0启用, 1冻结
						}
					}).then((res) => {
						this.isSubmiting = false;
						
						if (res.code == 0) {
							this.$Utils.showSuccess(res.msg);
							
							this.pageIndex = 1;
							this.getList();
							
						} else {
							this.$Utils.showTipInfo(res.msg);
						}
					}).catch((err) => {
						this.isSubmiting = false;
					});
				}
			});
		},
		
		//pager
		handlePageSizeChange(value) {
			this.pageIndex = 1;
			this.getList();
		},
		
		handlePageInput() {
			let value = ('' + this.pageInput).replace(/\D/g, '');
			let pageCount = Math.ceil(this.totalCount / this.curPageSize);
			if (value > pageCount) {
				value = pageCount;
			}
			this.pageInput = value;
		},
		handlePageEnter() {
			if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
			if (this.pageInput == 0) {
				this.pageInput = 1;
			}
			this.pageInput = parseInt(this.pageInput);
			this.pageIndex = this.pageInput;
			this.getList();
		},
		
		handlePageChange(value) {
			this.pageIndex = value;
			this.getList();
		}
	}
};
</script>

<style lang="scss" scoped>
@import 'AdminLog';
</style>
